export default __webpack_public_path__ + "static/media/safari-zone-back.f68ae7ba.png";